import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getInstance } from '../common/cache';
import { getLocalStorageItem, setLocalStorageItem } from '../common/persist-helpers';
/**
 * Cache implementation which always returns the persited response (if available).
 * But refreshes the response everytime its requested, so that next time onwards the data is up to date.
 *
 * Note - This will also return an expired result. This strategy should be used only in scenarios where:
 * 1. The data changes rarely.
 * 2. Its fine to serve the expired result to the user.
 */
export var refreshOnAccess = function refreshOnAccess(args) {
  var name = args.name;
  var cacheInstance = getInstance(args);
  var persistedState = getLocalStorageItem(name);
  if (persistedState) {
    cacheInstance.deserialize(persistedState);
  }
  var get = function get(key, returnExpired) {
    return cacheInstance.get(key, returnExpired !== null && returnExpired !== void 0 ? returnExpired : true);
  }; // fetch expired result by default.
  var set = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, result) {
      var serialized;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cacheInstance.set(key, result);
            _context.next = 3;
            return result;
          case 3:
            _context.next = 5;
            return cacheInstance.serialize();
          case 5:
            serialized = _context.sent;
            setLocalStorageItem(name, serialized);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function set(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var refreshOnAccessDecorator = function refreshOnAccessDecorator(key, supplier, returnExpired) {
    // cache hit
    var results = get(key, returnExpired);

    // cache refresh
    var apiPromise = supplier();
    // set the promise in the cache
    set(key, apiPromise);
    if (results) {
      // return the expired result
      return results;
    } else {
      // return the latest result
      return apiPromise;
    }
  };
  return {
    get: get,
    refreshOnAccessDecorator: refreshOnAccessDecorator
  };
};